import { Mapstyles } from './mapstyles';
import { FileSizeFormatter } from '@/file-size-formatter';

function onEachFeature(feature, layer) {
  layer.on('click', this.clickedFeature);
  layer.bindTooltip(this.generateTooltip(feature), { direction: 'top', sticky: true });
  layer.on('mouseover', this.mouseOverRegion);
  layer.on('mouseout', this.mouseOutRegion);
  layer.setStyle(this.calculateStyle(feature.properties.mapInfos, false));
}

function generateTooltip(feature) {
  if (feature.properties.mapInfos.upToDate) {
    return (
      '<div class="wb-type-copy tooltip">' +
      feature.properties.mapInfos.regionDescription +
      '</div>' +
      '<span class="wb-type-hint-strong">' +
      this.$t('overview.uptodate') +
      '</span> ' +
      feature.properties.mapInfos.installedMap +
      '</div>'
    );
  } else {
    return (
      '<div class="wb-type-copy tooltip">' +
      feature.properties.mapInfos.regionDescription +
      '</div>' +
      feature.properties.mapInfos.installedMap +
      ' <wb-icon class="update-chevron-icon" aria-hidden="true" name="chevron-right"></wb-icon> ' +
      feature.properties.mapInfos.availableMap +
      '</div>' +
      '<div class="wb-type-copy-tertiary">' +
      FileSizeFormatter.formatToGB(feature.properties.mapInfos.fileSize + feature.properties.mapInfos.sdsFileSize) +
      ' ' +
      this.$t('manualupdate.data.size.GB') +
      '</div>'
    );
  }
}

function mouseOverRegion(e) {
  let mapRegion = e.target.feature.properties.mapInfos;
  e.target.setStyle(this.calculateStyle(mapRegion, true));
}

function mouseOutRegion(e) {
  let mapRegion = e.target.feature.properties.mapInfos;
  e.target.setStyle(this.calculateStyle(mapRegion, false));
}

function calculateStyle(mapRegion, hovered) {
  let style = {};

  if (this.$store.state.manualUpdate.step === 1 && !mapRegion.upToDate) {
    Object.assign(style, Mapstyles.cursor_Click);
  } else {
    Object.assign(style, Mapstyles.cursor_Default);
  }

  if (mapRegion.upToDate) {
    if (this.$store.state.mapupdateInformation.offerFullInstall && this.$store.state.manualUpdate.completeMapSelected) {
      Object.assign(style, Mapstyles.upToDate_Clicked);
    } else {
      Object.assign(style, Mapstyles.upToDate);
    }
  } else {
    if (this.$store.state.manualUpdate.completeMapSelected) {
      Object.assign(style, Mapstyles.outdated_Clicked);
    } else if (this.$store.state.manualUpdate.selectedRegions.find((r) => r.regId === mapRegion.regId)) {
      Object.assign(style, Mapstyles.outdated_Clicked);
    } else {
      if (hovered) {
        Object.assign(style, Mapstyles.outdated_Hover);
      } else {
        Object.assign(style, Mapstyles.outdated);
      }
    }
  }

  if (
    mapRegion.selectedOTARegion &&
    this.$store.getters.isOtaSupportEnabled &&
    !this.$store.getters.isLivemapSupportEnabled
  ) {
    return Object.assign({}, style, Mapstyles.otaRegion);
  }
  return style;
}

function redrawMap() {
  this.mapRegionsWithGeoData = JSON.parse(JSON.stringify(this.mapRegionsWithGeoData));
}

export { onEachFeature, mouseOverRegion, mouseOutRegion, redrawMap, generateTooltip, calculateStyle };
